const FETCHING_SERVICE_TYPES = '@@phone/FETCHING_SERVICE_TYPES';
const FETCH_SERVICE_TYPES_SUCCESS = '@@phone/FETCH_SERVICE_TYPES_SUCCESS';
const FETCH_SERVICE_TYPES_FAILURE = '@@phone/FETCH_SERVICE_TYPES_FAILURE';

const apiHost = process.env.API_HOST || '';
const fetchServiceTypesEndpoint = `${apiHost}/api/web/2/phone/`;

export const PhoneActions = {
    FETCHING_SERVICE_TYPES,
    FETCH_SERVICE_TYPES_SUCCESS,
    FETCH_SERVICE_TYPES_FAILURE,
};

export const fetchingServiceTypes = () => ({
    type: PhoneActions.FETCHING_SERVICE_TYPES,
});

export const fetchServiceTypesSuccess = phoneData => ({
    type: PhoneActions.FETCH_SERVICE_TYPES_SUCCESS,
    phoneData,
});

export const fetchServiceTypesFailure = () => ({
    type: PhoneActions.FETCH_SERVICE_TYPES_FAILURE,
});

let fetching = false;
export function fetchServiceTypes() {
    return dispatch => {
        if (fetching) {
            return;
        }

        fetching = true;
        dispatch(fetchingServiceTypes());

        let responseStatus;
        return fetch(fetchServiceTypesEndpoint, {
            method: 'GET',
            headers: {
                Accept: 'application/json',
            },
            credentials: 'include',
        })
            .then(response => {
                fetching = false;
                responseStatus = response.status;
                if (responseStatus === 200) {
                    return response.json().then(body => {
                        if (body.data) {
                            dispatch(fetchServiceTypesSuccess(body.data));
                        } else {
                            dispatch(fetchServiceTypesFailure());
                        }
                    });
                } else {
                    dispatch(fetchServiceTypesFailure());
                }
            })
            .catch(() => {
                fetching = false;
                dispatch(fetchServiceTypesFailure());
            });
    };
}
